import { createListenerMiddleware } from '@reduxjs/toolkit'
import { LOCATION_CHANGE } from 'connected-react-router'
import { SET_BYPASS_REGION_EXCLUSION_OFFER_IDS, SET_BYPASS_REGION_FILTER } from 'actions/actionConstants'
import { getOfferBypassRegionFilterSetting } from 'api/promo'
import { setCookie } from 'lib/web/cookieUtils'

const BYPASS_COOKIE_KEY = 'bypass_region'
const EXCLUSION_IDS_COOKIE_KEY = 'bypass_region_exclusion_ids'
const COOKIE_TTL_SECONDS = 7 * 24 * 60 * 60 // 7 days

const bypassRegionMiddleware = createListenerMiddleware()

bypassRegionMiddleware.startListening({
  type: LOCATION_CHANGE,
  effect: async(_action, listenerApi) => {
    const state = listenerApi.getState() as App.State
    if (state.marketing.bypassRegionFilter) {
      listenerApi.unsubscribe()
      return
    }

    const { source, medium, campaign, term } = state.utm
    if (!source) {
      listenerApi.unsubscribe()
      return
    }

    listenerApi.unsubscribe()

    try {
      const result = await getOfferBypassRegionFilterSetting({
        source: source || undefined,
        medium: medium || undefined,
        campaign: campaign || undefined,
        term: term || undefined,
      })

      if (result.setting) {
        setCookie(BYPASS_COOKIE_KEY, 'true', COOKIE_TTL_SECONDS, '/', 'Lax', document.domain)
        listenerApi.dispatch({ type: SET_BYPASS_REGION_FILTER, value: true })
      }

      if (result.offer_region_filter_exclusion_offer_ids.length > 0) {
        setCookie(EXCLUSION_IDS_COOKIE_KEY, result.offer_region_filter_exclusion_offer_ids.join(','), COOKIE_TTL_SECONDS, '/', 'Lax', document.domain)
        listenerApi.dispatch({ type: SET_BYPASS_REGION_EXCLUSION_OFFER_IDS, offerIds: result.offer_region_filter_exclusion_offer_ids })
      }
    } catch {
      // non-critical — bypass stays false
    }
  },
})

export default bypassRegionMiddleware
